<ng-container *ngIf="showHeader">
    <img class="banner-img center-block div-print" src="https://gestionatupyme-public.s3.amazonaws.com/banner.png"
        alt="" />
</ng-container>

<mat-card class="simple-card mx-auto">
    <mat-card-content>
        <div class="row">

            <div class="col-12 d-flex justify-content-between" *ngIf="showHeader">
                <h1>Reporte TAG</h1>
                <button mat-flat-button class="custom-button-primary no-print"
                    [printTitle]='"Tag_"+(rut | rutFormat)+"_"+today' [useExistingCss]="true"
                    printSectionId="print-section" ngxPrint>
                    <mat-icon aria-hidden="false" aria-label="Icono de descarga" fontIcon="get_app"
                        class="icon-download"></mat-icon>
                    Descargar Resultado
                </button>
            </div>

            <div class="col-12 my-3" *ngIf="showHeader">
                <mat-chip-set aria-label="Rut principal">
                    <mat-chip class="chip-rut"><strong>RUT:</strong> {{content.DatosBasicosSolicitud.Rut | number:
                        '1.0-0'}}-{{content.DatosBasicosSolicitud.DV | uppercase}}</mat-chip>
                </mat-chip-set>
            </div>

            <div class="col-12">
                <mat-card>
                    <mat-card-header>
                        <mat-card-title class="font-size-title-card">
                            <mat-chip class="chip-info mr-2"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                            <span class="font-weight-bold text-color-black">Totales</span>
                        </mat-card-title>
                    </mat-card-header>

                    <mat-card-content>
                        <div class="p-5">
                            <div class="border grid p-5">
                                <div class="font-weight-500 text-color-black">Total:</div>
                                <div class="text-color-black">${{ content.Reporte.debtTotal | number: '1.0-0'}}</div>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>

            <div class="col-12 mt-5 mb-3">
                <mat-card>
                    <mat-card-header>
                        <mat-card-title class="font-size-title-card">
                            <mat-chip class="chip-info mr-2"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                            <span class="font-weight-bold text-color-black">Detalle</span>
                        </mat-card-title>
                    </mat-card-header>

                    <mat-card-content>

                        <div class="row p-5">
                            <div class="col-12 border mx-auto px-0">

                                <div class="table-responsive">
                                    <table mat-table matSort [dataSource]="debtsDataSource" class="custom-print-table">
                                        <ng-container matColumnDef="autopista">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Autopista</th>
                                            <td mat-cell *matCellDef="let element">{{ element.autopista }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="monto">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Monto</th>
                                            <td mat-cell *matCellDef="let element">${{ element.monto | number: '1.0-0' }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="vencimiento">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Vencimiento</th>
                                            <td mat-cell *matCellDef="let element">{{ element.vencimiento | date:'dd/MM/yyyy' }}</td>
                                        </ng-container>

                                        <tr mat-header-row *matHeaderRowDef="debtsDisplayedColumns"></tr>
                                        <tr mat-row *matRowDef="let row; columns: debtsDisplayedColumns;"></tr>

                                        <tr class="mat-mdc-row" *matNoDataRow>
                                            <td class="mat-mdc-cell text-center font-weight-500" [attr.colspan]="debtsDisplayedColumns.length">
                                                No hay datos disponibles
                                            </td>
                                        </tr>
                                    </table>
                                </div>

                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>

        </div>
    </mat-card-content>
</mat-card>